<template>
    <!--购买须知-->
    <div class="signUpNotice introduction bgF9F9F9 roundBorder4">
        <div class="title relative fWeight600" style="font-size: 100%">报名须知</div>
        <div class="padding16 lineHeight20r12f color999 font12r fWeight600">

            <p>1、课程性质:该课程为线下上课学习的课程，按实际报名的课程为学习内容。</p>
            <p>2、报名说明:课程报名会收取一定的定金(或全款费用)，报名成功后该定金(或全款)属于实位置预留，所以一旦定位成功，开课前5天内不予以退款，定金(或全款)在上课当天支付给主办方即可正式进场上课。</p>
            <p>3、进场说明:课前提前15分钟进场，打开微信【扫一扫】课程签到码提交报名信息即可出示信息供工作人员查看，审核通过即可进场。</p>
            <p>4、更多帮助:如有更多需要报名的课程详情可在【我的】-【在线咨询】咨询师讯相关客服人员；其余报名信息可咨询相关线下课程主办方客服人员。</p>

        </div>
    </div>
    <!--购买须知END-->
</template>

<script>
export default {
    name: "signUpNotice"
}
</script>

<style lang="scss" scoped>
.introduction {
    padding: 10px 0 18px;

    .title {
        position: relative;
        padding-left: 12px;

        &:before {
            display: block;
            content: '';
            position: absolute;
            width: 2px;
            height: 14px;
            background: #F55050;
            top: 5px;
            left: 0;
        }
    }
    p {
        margin: 0;
        letter-spacing: 1px;
    }
}
</style>
